module.exports = __webpack_public_path__ + "img/icon-user-black2.3360e1a8.svg";